import React, { useEffect } from "react";
import Ai from "../../../Images/AI-removebg-preview.png";
import "./Generative.css";
import ScrollMagic from "scrollmagic";

const Generativepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);
  const aiServices = [
    {
      title: "Custom AI Model Development",
      description: "Train domain-specific models using your data for high-impact results.",
    },
    {
      title: "AI-Powered Chatbots & Virtual Assistants",
      description: "Deliver natural, real-time support and engagement at scale.",
    },
    {
      title: "Content Automation",
      description:
        "Generate high-quality text, summaries, emails, or reports tailored to your brand voice.",
    },
    {
      title: "Image & Video Generation",
      description: "Create marketing visuals, prototypes, or synthetic media assets on demand.",
    },
    {
      title: "Code Generation & Optimization",
      description: "Speed up software development using AI tools that write or review code.",
    },
    {
      title: "AI Integration & APIs",
      description:
        "Seamlessly embed AI capabilities into your existing tools, workflows, or customer-facing products.",
    },
  ];

  return (
    <div>
      <div className="banner-generative" id="triggerPinned">
        <h1>Next-Gen AI That Creates, Innovates, and Delivers</h1>
      </div>
      <div className="white-section">
        <div className="about-generative-ai">
          <div className="left-content-ai">
            <h1>Unlock Creativity and Productivity with AI</h1>
            <p>
              At Owision, we’re pioneering the use of Generative AI to transform how businesses
              work, create, and innovate. From intelligent automation to content generation and
              beyond, our AI solutions enhance productivity and open up new possibilities across
              industries.
            </p>
          </div>
          <div className="right-content-ai">
            <img src={Ai} alt="ai image" />
          </div>
        </div>
        <div className="generative-card-caontainer">
          <h1> Our Generative AI Capabilities</h1>
          <div className="generative-card-list">
            {aiServices.map((service, index) => (
              <div className="generative-card" key={index}>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Generativepage;
